"use client";

import { SupportEmailButton } from "./support-email";
import { usePathname } from "next/navigation";
import { useTranslations } from "next-intl";

export function SupportButtonNotFound() {
  const pathname = usePathname();
  const t = useTranslations("SupportNotFound");

  return (
    <SupportEmailButton
      subject={t("subject")}
      body={t("body", { pathname })}
      plain
    >
      {t("buttonText")} <span aria-hidden="true">&rarr;</span>
    </SupportEmailButton>
  );
}
